import React from 'react';

const AgencyQueueTable = ({ rows, completedKey, completedLabel }) => {
  const maximum = Math.max(1, ...rows.map((row) => row[completedKey] + row.awaiting));

  return (
    <>
      <table
        className="hidden w-full table-fixed border-collapse text-sm sm:table"
        aria-label={`${completedLabel} et en attente par société`}
      >
        <colgroup>
          <col className="w-[27%]" />
          <col className="w-[53%]" />
          <col className="w-[10%]" />
          <col className="w-[10%]" />
        </colgroup>
        <thead>
          <tr className="border-b text-[13px] text-slate-500">
            <th className="pb-3 text-left font-normal">Société</th>
            <th aria-label="Répartition" />
            <th className="pb-3 text-right font-normal">{completedLabel}</th>
            <th className="pb-3 text-right font-normal">En attente</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((agency) => (
            <tr key={agency.id} className="h-12 border-b">
              <td className="break-words py-3 pr-6">{agency.name}</td>
              <td className="py-3 pr-6">
                <div className="flex h-1.5 max-w-[420px] overflow-hidden rounded-sm" aria-hidden="true">
                  <div className="bg-emerald-600" style={{ width: `${(agency[completedKey] / maximum) * 100}%` }} />
                  <div className="bg-[#d1dcd5]" style={{ width: `${(agency.awaiting / maximum) * 100}%` }} />
                </div>
              </td>
              <td className={`py-3 text-right ${agency[completedKey] === 0 ? 'text-slate-400' : ''}`}>
                {agency[completedKey].toLocaleString('fr-FR')}
              </td>
              <td
                className={`py-3 text-right text-base font-semibold ${agency.awaiting === 0 ? 'text-slate-400' : ''}`}
              >
                {agency.awaiting.toLocaleString('fr-FR')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="sm:hidden">
        {rows.map((agency) => (
          <div key={agency.id} className="grid grid-cols-[1fr_auto] items-center gap-x-3 gap-y-2 border-b py-3 text-sm">
            <span className="col-span-2 break-words font-semibold">{agency.name}</span>
            <div className="order-last col-span-2 flex h-1.5 overflow-hidden rounded-sm" aria-hidden="true">
              <div className="bg-emerald-600" style={{ width: `${(agency[completedKey] / maximum) * 100}%` }} />
              <div className="bg-[#d1dcd5]" style={{ width: `${(agency.awaiting / maximum) * 100}%` }} />
            </div>
            <span className={agency[completedKey] === 0 ? 'text-slate-400' : ''}>
              <span className="text-[13px] text-slate-500">{completedLabel} </span>
              {agency[completedKey].toLocaleString('fr-FR')}
            </span>
            <strong className={`text-right text-base ${agency.awaiting === 0 ? 'text-slate-400' : ''}`}>
              <span className="text-[13px] font-normal text-slate-500">En attente </span>
              {agency.awaiting.toLocaleString('fr-FR')}
            </strong>
          </div>
        ))}
      </div>
      {!rows.length && <p className="py-4 text-sm text-slate-500">Aucune société pour cette campagne.</p>}
      <p className="mt-3 flex gap-4 text-xs text-slate-500">
        <span>
          <span className="mr-1 inline-block h-2 w-2 bg-emerald-600" />
          {completedLabel}
        </span>
        <span>
          <span className="mr-1 inline-block h-2 w-2 bg-[#d1dcd5]" />
          En attente
        </span>
      </p>
    </>
  );
};

export default AgencyQueueTable;
